import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Header from "../../Layouts/Header";
import Loading from "../../Layouts/Loading";

import InvitePic from "../../Assets/Images/invite.jpg";

const currencyFormat = Intl.NumberFormat('en-US');

const Reagents = () => {

    const [users , setUsers] = React.useState([]);
    const [ , setHasToken] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        else {
            setHasToken(true)
            setIsLoaded(false);

            API.getReagents()
                .then((response) => {
                    setIsLoaded(true);
                    setUsers(response.data);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }, []);


    return (
        <React.Fragment>

            <Header title='  افراد معرفی شده توسط شما ' hasBack={true} />
            {
                !isLoaded && <Loading />
            }

            <main className="container-fluid rtl ">
                <div className="row px-3 ">
                    <div className="col-12 " >
                        <img src={InvitePic} alt="پخش من" className="rounded mx-auto d-block mt-5 w-100" />
                    </div>
                </div>
                {
                    isLoaded && users.map (user => {
                        return (
                            <div className="row score-row m-3 p-3" key={user.id}>
                                <div className="col-7 text-small-1 fw-bold">
                                    {user.name}
                                    &nbsp;
                                    {user.surname}
                                    <div className='fw-normal text-end text-small-3 text-muted mt-2 ltr border-bottom'>
                                        {user.mobile}
                                    </div>
                                </div>
                                <div className="col-5 fw-bold pt-3 text-secondary text-small-3 text-start border-bottom">

                                    {user.date}

                                </div>
                                <div className="col-4 text-small-3 pt-2">

                                          ماه جاری


                                </div>
                                <div className="col-8 text-small-1 fw-bold text-start  pt-2 text-primary-color">
                                    {
                                        user.is_marketer >= 0 ?
                                            currencyFormat.format(user.sum) : '****'
                                    }

                                    &nbsp;
                                    ریال
                                </div>
                                <div className="col-4 mt-2 text-small-3 pt-2">

                                          ماه گذشته


                                </div>
                                <div className="col-8 mt-2 text-small-2 fw-bold text-start  pt-2 text-primary-color">
                                    {
                                        user.is_marketer >= 0 ?
                                            currencyFormat.format(user.sum_last_month) : '****'
                                    }

                                    &nbsp;
                                    ریال
                                </div>
                            </div>
                        )
                    })
                }
            </main>

        </React.Fragment>
    );
};

export default Reagents;